import { Navigate } from 'react-router-dom';
import jwtUtils from '../utilities/jwtUtils';

const ProtectedRouteCajero = ({ element }) => {
  const payload = jwtUtils.getValidRefreshTokenPayload();
  if (!payload) {
    return <Navigate to="/401" replace />;
  }

  if (payload.rol !== 'cajero') {
    return <Navigate to="/401" replace />;
  }

  return element;

};

export default ProtectedRouteCajero;
